/* import { RequestBuilder, mapRequests } from "@lernetz/request";
import { createModelApi, type ModelApiType } from "@lernetz/svelte-model-api";
import { processIn } from "@lernetz/svelte-model-api/process";
import { ModelGateway } from "@lernetz/svelte-model-api";

export let modelGateway: ModelGateway;

export var requests: {
    icons: RequestBuilder;
    api: {
        model: RequestBuilder;
    };
};

export var data: {
    baseUrl: string,
};

export let modelApi: ModelApiType;

export function setupData( init: { data: any, routes: any; } ) {
    if( !init ) {
        return;
    }

    requests = mapRequests( init.routes );
    data = processIn( init.data );
    data = init.data;

    modelApi = createModelApi( {
        base: requests.api.model
    } );

    modelGateway = new ModelGateway( {
        base: requests.api.model
    } );

}
 */
import { RequestBuilder, mapRequests } from "@lernetz/request";
import { page } from "@inertiajs/svelte";
import { get } from 'svelte/store';
import { FlinkGateway } from "./gateway/FlinkGateway";
import { set, locale } from "@lernetz/svelte-translate";

export var sharedProps: any;
export var flinkGateway: FlinkGateway;

export function setupSharedProps() {

    let pageStore = get( page );
    sharedProps = pageStore.props.shared;
    // inject page props
    sharedProps.pageUrl = ( pageStore as any ).url as string;
    sharedProps.pageComponent = ( pageStore as any ).component as string;

    flinkGateway = new FlinkGateway( {
        base: new RequestBuilder(sharedProps.flinkUrl)
    });


    set( sharedProps.currentLocale, sharedProps.lang );
    locale.set( sharedProps.currentLocale );

    // setup request builders
    requests = mapRequests( sharedProps.routes );
}

export var requests: {
    icons: RequestBuilder;
    assets: RequestBuilder,
    flink: {
        base: RequestBuilder,
        assets: RequestBuilder,
        collectionMaterial: RequestBuilder;
    },
    api: {
        model: RequestBuilder;
        saveGroups: RequestBuilder;
        setLang: RequestBuilder;
    };
};
